// extracted by mini-css-extract-plugin
export default {"showMain":"style_showMain__YAGqb"};